exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".searchGroup__group___13N2f {\n  padding-left: 30px;\n  padding-right: 25px;\n  padding-bottom: 25px; }\n  .searchGroup__group___13N2f > div:last-child {\n    margin-bottom: 0; }\n\n.searchGroup__groupMobile___1eliy {\n  padding-left: 15px;\n  padding-right: 15px;\n  padding-bottom: 25px; }\n\n.searchGroup__groupName___vS43y {\n  font-size: 18px;\n  margin-top: 20px;\n  font-weight: 500;\n  margin-bottom: 10px; }\n", ""]);

// exports
exports.locals = {
	"group": "searchGroup__group___13N2f",
	"groupMobile": "searchGroup__groupMobile___1eliy",
	"groupName": "searchGroup__groupName___vS43y"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/SearchControls/SearchGroups/SearchGroup/searchGroup.scss
// module id = 4251
// module chunks = 6